import {inject, Injectable} from '@angular/core';
import {AuthenticationApiClient} from "src/app/infrastructure/moovement-api/web-api/authentication.api-client";
import {PushNotifications} from "@capacitor/push-notifications";
import {environment} from "src/app/environments/environment";
import {DataStorageService} from "src/app/infrastructure/data-storage.service";
import {UserAgent} from "src/app/infrastructure/moovement-api/models/user";
import {Router} from '@angular/router';

@Injectable({providedIn: 'root'})
export class LogoutService {

  private router = inject(Router);

  constructor(
    private authenticationApiClient: AuthenticationApiClient,
    private dataStorageService: DataStorageService
  ) {}

  logout(): void {
    if (environment.platform != 'web') {
      PushNotifications.unregister().then(() => {
        this.signOutAndUnregisterUserAgent();
      }).catch(_ => {
        this.signOutAndUnregisterUserAgent()
      })
    } else {
      this.signOutAndUnregisterUserAgent();
    }
  }

  private signOutAndUnregisterUserAgent() {
    this.dataStorageService.getValueByKey<UserAgent>('userAgent').then(userAgent => {
      if (userAgent) {
        this.signOut({deviceId: userAgent.id})
      } else this.signOut()
    })
  }

  private async signOut(authenticationMetadata?: AuthenticationMetadata): Promise<void> {
    const token = await this.dataStorageService.getValueByKey<string>('authToken');
    if (token) {
      this.authenticationApiClient.signOut(authenticationMetadata).subscribe({
        next: _ => {
          this.finalizeSession();
        },
        error: error => {
          console.log("Error during logout sequence", JSON.stringify(error));
          this.finalizeSession();
        }
      })
    } else {
      this.finalizeSession();
    }
  }

  private async finalizeSession() {
    await this.dataStorageService.removeKeyValue('userAgent');
    await this.dataStorageService.removeKeyValue('authToken');
    await this.dataStorageService.removeKeyValue('user');
    await this.dataStorageService.removeKeyValue('lastSelectedFarmReference');
    this.router.navigate(['/login']);
  }
}

export interface AuthenticationMetadata {
  deviceId: string;
}

export interface SessionMetadata {
  userId: string;
  verifier: string;
  userAgent: UserAgent;
}
